import(/* webpackMode: "eager", webpackExports: ["HomeClient"] */ "/workspace/src/app/home-client.tsx");
